export default __webpack_public_path__ + "static/media/money-collect.68d8524c.svg";